import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Layout from "../../../components/Layout";
import { TextField } from "@material-ui/core";

import deleteIcon from "../../../assets/img/delete-red.svg";

import { getCategories, getCepCoordinates, getUserEstablishment } from "../../../config/utils";
import { ConfirmDelete } from "../../../components/Alert";
import api from "../../../config/api";
import Spinner from "react-bootstrap/Spinner";
import PriceInputLoja from "../../../components/inputs/PriceInputLoja";
import InputWeekDay from "./components/InputWeekDay/InputWeekDay";
import { useAuth } from "../../../context/ContextApi";
import PaymentMethodsMultipleSelect from "../../../components/inputs/MultiSelect/PaymentMethodsMultipleSelect";
import TextCepMask from "../../../components/Mask/TextCepMask";
import ReactInputMask from "react-input-mask";
import { ListBodyItemSwitch } from "../../../components/_widgets/WidgetsList";
import swal from "sweetalert";
import { Skeleton } from "@mui/material";
import PriceInput from "../../../components/inputs/PriceInput";
import NumberFormat from "react-number-format";

require("dotenv").config();

function StoreInfos() {
  // const [makeTransport, setMakeTransport] = useState(false);
  const [professionals, setProfessionals] = useState([]);

  const [categories, setCategories] = useState([]);
  const [extraServices, setExtraService] = useState([]);

  const [storeNameError, setStoreNameError] = useState(false);

  const [establishment, setEstablishment] = useState({});
  const [imageId, setImageId] = useState("");
  const [loadBtn, setLoadBtn] = useState(false);
  const [loadBtnPhoto, setLoadBtnPhoto] = useState(false);
  const [imageLoad, setImageLoad] = useState([false, 0]);
  const { userId, userEstablishment, isBeautyEstablishment, isPetEstablishment } = useAuth();

  const [timeVariations, setTimeVariations] = useState([]);

  const getTimeVariations = async () => {
    try {
      const response = await api
        .get(`/establishment-reserve-hours?establishment=${userEstablishment}&paginate=true`)
        .then((res) => res.data.docs);

      setTimeVariations(response);
    } catch (error) {
      console.log("Get Time Variations " + error);
    }
  };
  const editTimeVariations = async (weekDay, id, hours) => {
    try {
      // console.log(weekDay, id, hours);
      const data = {
        weekDay: weekDay,
        hours: hours,
      };
      await api.put(`/establishment-reserve-hours/${id}`, data).then(() => {
        getTimeVariations();
      });
    } catch (error) {
      console.log("Put Time Variations " + error);
    }
  };

  const selectImage = async (e) => {
    setLoadBtnPhoto(true);
    if ((e !== undefined) & (e !== null)) {
      if (e.target.files && e.target.files[0]) {
        const dataup = new FormData();
        try {
          const establishment = await getUserEstablishment(localStorage.getItem("@Reservei:userId"));
          dataup.append("file", e.target.files[0]);
          dataup.append("_id", establishment[0]._id);
          await api
            .post("/establishment-new-image", dataup, {
              headers: {
                "content-type": "multipart/form-data",
              },
            })
            .then(async (resp) => {
              getEstablishment();
              // await handleSubmit();
            });
        } catch (error) {
          console.log("selectImage error", error.message);
          setLoadBtnPhoto(false);
          return swal("Erro", "Tipo de imagem não suportada", "error");
        } finally {
          getEstablishment();
        }
      }
    }
  };

  const removeImage = async () => {
    const establishment = await getUserEstablishment(localStorage.getItem("@Reservei:userId"));
    await api
      .put(`/establishment-delete-photo/${establishment[0]._id}`, {
        id: imageId,
      })
      .then((res) => {
        if (res.data.success) {
          getEstablishment();
        }
      });
  };

  const getEstablishment = async () => {
    try {
      let response = await api.get(`/establishment?user=${userId}`).then((resp) => {
        setEstablishment(() => resp.data[0]);
        setExtraService(resp.data[0].extraServices);
      });
      if (response?.data.length > 0) {
        await getProfessionals(response.data[0]._id);
      }
    } catch (error) {
      console.log("getEstablishment error", error.message);
    } finally {
      setLoadBtnPhoto(false);
    }
  };

  const getProfessionals = async (establishment) => {
    let response = await api.get(`/professional?establishment=${establishment}`);
    setProfessionals(response.data);
  };

  const getAllCategory = async () => {
    let response = await getCategories();
    setCategories(response);
  };

  const handleChange = (event) => {
    if (event.target.name === "category") {
      setEstablishment((values) => ({
        ...values,
        category: { _id: event.target.value },
      }));
    } else {
      setEstablishment((values) => ({
        ...values,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleChangeCep = async (e) => {
    if (e.target.value.length < 9) {
      return;
    }
    const { lat, long, error: cepError, data } = await getCepCoordinates(e.target.value);
    if (data) {
      setEstablishment((prevState) => ({
        ...prevState,
        address: data.logradouro,
        district: data.bairro,
        city: data.localidade,
        state: data.uf,
        longitude: long,
        latitude: lat,
        extraServices,
      }));
    }
  };

  const handleSubmit = async () => {
    let object = { ...establishment, extraServices };
    if (!object.storeName) {
      setStoreNameError(true);
      return;
    }
    setStoreNameError(false);
    setLoadBtn(true);

    if (establishment.cep) {
      const { lat, long, error: cepError, data } = await getCepCoordinates(establishment.cep);
      object = {
        ...establishment,
        address: data.logradouro,
        district: data.bairro,
        city: data.localidade,
        state: data.uf,
        longitude: long,
        latitude: lat,
        extraServices,
      };
    }
    try {
      await api.put(`/establishment-update/${establishment._id}`, object).then((res) => {
        if (res.data.success) {
          document.getElementById("btnCallSuccess").click();
          getEstablishment();
          setLoadBtn(false);
        }
      });
    } catch (error) {
      console.log("handleSubmit error", error.message);
    } finally {
      setLoadBtn(false);
    }
    setLoadBtn(false);
  };

  function handleNameChange(value, id, tipo) {
    let inputs = extraServices.slice();
    for (let i in inputs) {
      if (i == id) {
        if (tipo == "name") {
          inputs[i].name = value;
        } else {
          inputs[i].price = value;
        }

        break;
      }
    }
    setExtraService(inputs);
  }

  function removeServiceFromArray(index) {
    const removedImage = extraServices.filter((e, i) => i !== index);

    setExtraService(removedImage);
  }

  useEffect(() => {
    getEstablishment();
    getAllCategory();
    getTimeVariations();
    // console.log(establishment);
  }, [userId]);

  return (
    <>
      <Layout defaultMenu={3} title={"Dados da loja"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="row ">
            <div className="d-block col-4  justify-content-end">
              <button
                onClick={() => handleSubmit()}
                className="ms-auto btn bg-gradient-theme-blue text-white rounded-2 fz-16 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4"
              >
                {loadBtn ? (
                  <>
                    Salvando
                    <Spinner animation="border" role="status" size="sm" />
                  </>
                ) : (
                  "Salvar alterações"
                )}
              </button>
            </div>
            <Tabs defaultActiveKey="1" id="uncontrolled-tab-example" className="d-flex mb-5 col-8 order-first">
              <Tab eventKey="1" title="Dados gerais">
                <div className="row">
                  <div className="col-lg-4 pe-lg-3">
                    <TextField
                      defaultValue={establishment.storeName ? establishment.storeName : " "}
                      onChange={(e) => handleChange(e)}
                      value={establishment.storeName || ""}
                      name="storeName"
                      label={"Nome da empresa"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                      error={storeNameError}
                      required
                    />
                  </div>

                  <div className="col-lg-4 px-lg-3">
                    {/* <TextField
                      defaultValue={establishment.category ? establishment.category : " "}
                      onChange={(e) => handleChange(e)}
                      value={establishment.category !== undefined ? establishment.category._id : ""}
                      name="category"
                      variant="outlined"
                      select
                      label="Tipo de negócio"
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                      disabled
                    >
                      {categories.map((item, index) => (
                        <MenuItem key={index} value={item._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField> */}
                    <TextField
                      defaultValue={establishment.workingHours ? establishment.workingHours : ""}
                      onChange={(e) => handleChange(e)}
                      name="workingHours"
                      value={establishment.workingHours || ""}
                      label={"Horário de atendimento"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 ps-lg-3">
                    <TextField
                      onChange={(e) => {
                        handleChange(e);
                        handleChangeCep(e);
                      }}
                      defaultValue={establishment.cep ? establishment.cep : " "}
                      value={establishment.cep || " "}
                      name="cep"
                      label={"CEP"}
                      variant={"outlined"}
                      InputProps={{
                        inputComponent: TextCepMask,
                        shrink: true,
                      }}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 pe-lg-3 mt-0 mt-lg-3">
                    <TextField
                      defaultValue={establishment.address ? establishment.address : " "}
                      onChange={(e) => handleChange(e)}
                      value={establishment.address || ""}
                      name="address"
                      label={"Endereço"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 px-lg-3 mt-0 mt-lg-3">
                    <TextField
                      defaultValue={establishment.district ? establishment.district : " "}
                      onChange={(e) => handleChange(e)}
                      value={establishment.district || ""}
                      name="district"
                      label={"Bairro"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 ps-lg-3 mt-0 mt-lg-3">
                    <TextField
                      defaultValue={establishment.city ? establishment.city : " "}
                      onChange={(e) => handleChange(e)}
                      name="city"
                      value={establishment.city || ""}
                      label={"Cidade"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 pe-lg-3 mt-0 mt-lg-3">
                    <TextField
                      defaultValue={establishment.state ? establishment.state : " "}
                      onChange={(e) => handleChange(e)}
                      name="state"
                      value={establishment.state || ""}
                      label={"Estado"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 pe-lg-3 mt-0 mt-lg-3">
                    <TextField
                      defaultValue={establishment.addressComplement ? establishment.addressComplement : ""}
                      onChange={(e) => handleChange(e)}
                      name="addressComplement"
                      value={establishment.addressComplement || ""}
                      label={"Complemento"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 pe-lg-3 mt-0 mt-lg-3">
                    <PaymentMethodsMultipleSelect
                      label={"Métodos de pagamento"}
                      handleChange={handleChange}
                      payments={establishment?.payments || []}
                    />
                  </div>
                </div>
                {isPetEstablishment ? (
                  <div className="col-lg-4 pe-lg-3 mt-0 mt-lg-3">
                    <NumberFormat
                      customInput={TextField}
                      required
                      variant="outlined"
                      label={"Valor transporte leva e traz"}
                      thousandSeparator={"."}
                      decimalSeparator=","
                      prefix={"R$ "}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      name="transPrice"
                      placeholder="R$ 0,00"
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                      value={establishment.transPrice || ""}
                      onValueChange={(values) => {
                        const { floatValue } = values;
                        handleChange({
                          target: { name: "transPrice", value: floatValue },
                        });
                      }}
                    />
                  </div>
                ) : (
                  <></>
                )}
                <div className="d-flex">
                  <div className="col-10 col-lg-8 pe-2 mt-lg-3 me-lg-3">
                    <TextField
                      defaultValue={establishment.differentials ? establishment.differentials : " "}
                      onChange={(e) => handleChange(e)}
                      name="differentials"
                      value={establishment.differentials || ""}
                      label={"Diferenciais"}
                      variant={"outlined"}
                      className="fz-16 text-cl-dark-jungle-green ff-univanova mb-3 w-100"
                      multiline
                      minRows={4}
                    />
                  </div>
                  <div className="col-4  mt-lg-3">
                    <ListBodyItemSwitch
                      paymentApp={"Aceita receber pelo APP"}
                      name={"paymentApp"}
                      sizeLg={5}
                      onClick={(e) =>
                        handleChange({ target: { name: "paymentApp", value: !establishment?.paymentApp } })
                      }
                      value={establishment?.paymentApp}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-8 pe-2 mt-lg-3">
                  <TextField
                    defaultValue={establishment.ideal ? establishment.ideal : " "}
                    onChange={(e) => handleChange(e)}
                    name="ideal"
                    value={establishment.ideal || ""}
                    label={"Ideal para"}
                    variant={"outlined"}
                    className="fz-16 text-cl-dark-jungle-green ff-univanova mb-3 w-100"
                    multiline
                    minRows={4}
                  />
                </div>
                <div className="col-12 mt-1 mb-3">
                  <span className="text-cl-black-2 ff-univanova-medium fz-20">Fotos do estabelecimento</span>
                </div>
                <form>
                  <div className="row m-0 mb-5">
                    {establishment.establishmentPhoto !== undefined ? (
                      <>
                        {establishment.establishmentPhoto.map((item, index) => (
                          <div
                            data-bs-toggle="modal"
                            data-bs-target={"#confirmDeleteImage"}
                            key={index}
                            onClick={() => setImageId(item._id)}
                            className={`establishment-image c-pointer p-0 mt-2 me-2`}
                            style={{ height: "137px", width: "auto" }}
                          >
                            {imageLoad[0] && imageLoad[1] === item.url ? (
                              <div class="delete-establishment-container">
                                <svg
                                  id="delete_black_24dp"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                >
                                  <path id="Caminho_902" data-name="Caminho 902" d="M0,0H24V24H0Z" fill="none" />
                                  <path
                                    id="Caminho_903"
                                    data-name="Caminho 903"
                                    d="M16,9V19H8V9h8M14.5,3h-5l-1,1H5V6H19V4H15.5ZM18,7H6V19a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2Z"
                                    fill="#CB0004"
                                  />
                                </svg>
                                <div>Excluir foto</div>
                              </div>
                            ) : (
                              <></>
                            )}
                            <img
                              src={item.url}
                              className="w-100 h-100 img-fluid"
                              alt=""
                              onLoad={() => setImageLoad([true, item.url])}
                            />
                          </div>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                    <label
                      htmlFor="file"
                      className={` bg-cl-chinese-white d-flex mt-2  justify-content-center align-items-center flex-column c-pointer `}
                      style={{ height: "137px", width: "187px" }}
                    >
                      {loadBtnPhoto ? (
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      ) : (
                        <>
                          <i className="bi bi-plus-circle fz-26 fa-lg text-cl-light-blue-steel"></i>
                          <span className="text-cl-philippine-silver ff-univanova-medium fz-16">Adicionar foto</span>
                        </>
                      )}
                      <input type="file" id="file" onInput={(e) => selectImage(e)} className="d-none" required />
                    </label>
                  </div>
                </form>
              </Tab>
              <Tab eventKey="2" title="Informações de contato">
                <div className="row">
                  <div className="col-lg-4 pe-lg-3 mt-0 mt-lg-2">
                    <ReactInputMask
                      mask="(99)99999-9999"
                      value={establishment.phone || ""}
                      defaultValue={establishment.phone ? establishment.phone : " "}
                      onChange={(e) => handleChange(e)}
                    >
                      {() => (
                        <TextField
                          name="phone"
                          label={"Celular"}
                          variant={"outlined"}
                          className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                        />
                      )}
                    </ReactInputMask>
                  </div>
                  <div className="col-lg-4 px-lg-3 mt-0 mt-lg-2">
                    <TextField
                      defaultValue={establishment.whatsapp ? establishment.whatsapp : " "}
                      onChange={(e) => handleChange(e)}
                      name="whatsapp"
                      value={establishment.whatsapp || ""}
                      label={"Whatsapp"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 ps-lg-3 mt-0 mt-lg-2">
                    <TextField
                      defaultValue={establishment.email ? establishment.email : " "}
                      onChange={(e) => handleChange(e)}
                      name="email"
                      value={establishment.email || ""}
                      label={"E-mail"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 pe-lg-3 mt-0 mt-lg-3">
                    <TextField
                      defaultValue={establishment.site ? establishment.site : " "}
                      onChange={(e) => handleChange(e)}
                      name="site"
                      value={establishment.site || ""}
                      label={"Site"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 px-lg-3 mt-lg-3">
                    <TextField
                      defaultValue={establishment.facebook ? establishment.facebook : " "}
                      onChange={(e) => handleChange(e)}
                      name="facebook"
                      value={establishment.facebook || ""}
                      label={"Facebook"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                  <div className="col-lg-4 ps-lg-3 mt-lg-3">
                    <TextField
                      defaultValue={establishment.instagram ? establishment.instagram : " "}
                      onChange={(e) => handleChange(e)}
                      name="instagram"
                      value={establishment.instagram || ""}
                      label={"Instagram"}
                      variant={"outlined"}
                      className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                    />
                  </div>
                </div>
              </Tab>
              {!isBeautyEstablishment ? (
                <Tab eventKey="3" title="Horários de reserva">
                  <div className="col-12 col-lg-8 flex-column ">
                    {timeVariations ? (
                      <>
                        {timeVariations.map((weekDay) => (
                          <InputWeekDay
                            weekDay={weekDay.weekDay}
                            timeVariations={weekDay.hours}
                            editTimeVariations={editTimeVariations}
                            weekDayId={weekDay._id}
                          />
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </Tab>
              ) : (
                <></>
              )}

              <Tab eventKey="4" title="Serviços extras">
                {extraServices.map((services, index) => (
                  <>
                    <div className="row" key={index}>
                      <div className="col-lg-4 ps-lg-0 mt-lg-2">
                        <TextField
                          // defaultValue={
                          //   services.name
                          // }
                          onChange={(e) => handleNameChange(e.target.value, index, "name")}
                          name="extraservicename"
                          value={services.name}
                          label={"Digite seus serviços extras (opcional)"}
                          variant={"outlined"}
                          className="w-100 fz-16 text-cl-black-4 ff-univanova mb-3"
                        />
                      </div>
                      <div className="col-lg-4 ps-lg-0 mt-lg-2 d-flex align-items-center">
                        <PriceInputLoja
                          input={services.price}
                          label="Preço *"
                          onValueChange={(values) => {
                            const { floatValue } = values;
                            handleNameChange(floatValue, index, "price");
                          }}
                        />

                        <div className="ms-3 d-flex c-pointer" onClick={() => removeServiceFromArray(index)}>
                          <img alt="delete variation" className="" src={deleteIcon} />
                        </div>
                      </div>
                    </div>
                  </>
                ))}

                <p
                  style={{ cursor: "pointer" }}
                  onClick={() => setExtraService([...extraServices, { name: "", price: 0 }])}
                >
                  + Adicionar serviço
                </p>
              </Tab>
            </Tabs>
          </div>
        </div>
      </Layout>
      <button id="btnCallSuccess" className="d-none" data-bs-toggle="modal" data-bs-target="#StoreInfo">
        Chamar modal success
      </button>
      <div
        className="modal fade border-0"
        id="StoreInfo"
        tabIndex="-1"
        aria-labelledby="myModalAlertLogOutLabel"
        aria-hidden="true"
        style={{ borderRadius: "10px" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 p-4">
              <button
                type="button"
                id="btnCloseSingle"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="d-flex flex-column modal-body pt-0 px-5 pb-4">
              <span style={{ textAlign: "center" }} className="text-cl-black ff-univanova-bold fz-24">
                Salvo!
              </span>
              <span
                style={{ textAlign: "center" }}
                className="mt-3 d-flex text-cl-black justify-content-center ff-univanova-regular fz-14"
              >
                Alterações realizadas com sucesso!
              </span>
              <div className="row my-3 mx-0">
                <div className="col-12 d-flex align-items-center justify-content-center px-0 mt-3">
                  <button type="submit" data-bs-dismiss="modal" className="btn bg-gradient-theme-blue text-white px-4">
                    Ok!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Success
        id="StoreInfo"
        title={"Seu Alterações realizadas com sucesso!"}
        description="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero."
      /> */}

      <button
        id="btnCallSuccessPutProfessional"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#SuccessPutProfesional"
      >
        Chamar modal success
      </button>

      <ConfirmDelete
        id="confirmDeleteImage"
        onClick={removeImage}
        title={"Tem certeza que quer excluir esta imagem?"}
        text={"Excluir "}
      />
    </>
  );
}

export default StoreInfos;
